<footer class="footer py-4">
    <div class="container">
        <div class="row justify-content-between align-items-center font-size-1">
            <div class="col-md-6 mb-2 mb-md-0">
                <p class="mb-0 text-white">Filparty Explorer &copy; {{footer}} &nbsp; | &nbsp;<a class="text-white-70" href="">Donate</a>&nbsp;<fa-icon [icon]="faHeart" class="fas fa-heart text-danger"></fa-icon></p>
            </div>
            <div class="col-md-6 text-md-right">
                <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                        <a class="btn btn-sm btn-icon btn-soft-light btn-pill" href="https://twitter.com/filparty" rel="nofollow noopener" target="_blank" data-toggle="tooltip" data-placement="top" title="" data-original-title="Twitter">
                            <fa-icon [icon]="faTwitter" class="fab fa-twitter"></fa-icon>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a class="btn btn-sm btn-icon btn-soft-light btn-pill" href="https://discord.gg/dBsdgN2rMm" rel="nofollow noopener" target="_blank" data-toggle="tooltip" data-placement="top" title="" data-original-title="Discord">
                            <fa-icon [icon]="faDiscord" class="fab fa-facebook"></fa-icon>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>